// extracted by mini-css-extract-plugin
export default {"font-renta":"ErrorCodesList_font-renta__ZP00y","containerList":"ErrorCodesList_containerList__B2tPS","pageDescription":"ErrorCodesList_pageDescription__9VXz1"};